import React from 'react';
import { Link } from 'react-router-dom';
import '../css-coding/BlogIntro.css';
import articleImage1 from '../assets/Article_img_1.png';
import articleImage2 from '../assets/Article_img _2.png';
import articleImage3 from '../assets/Article_img_3.png';


const Blog = () => {
  const blogs = [
    {
      id: 1,
      title:
        "Why Personal Branding Is Important in 2026 (And How It Can Grow Your Business)",
      date: "Jan 1, 2026",
      tag: "Blog 1",
      image: articleImage2,
      link: "/article1",
      readTime: "9 Min read",
    },
    {
      id: 2,
      title: "5 Best Video Editing Software in 2026 (And How to Choose the Right One for Your Success)",
      date: "Jan 2, 2026",
      tag: "Blog 2",
      image: articleImage1,
      link: "/article2",
      readTime: "7 Min read",
    },
    {
      id: 3,
      title: "How to Earn ₹1 Lakh Per Month as a Video Editor in 2026",
      date: "Jan 3, 2026",
      tag: "Blog 3",
      image: articleImage3,
      link: "/article3",
      readTime: "6 Min read",
    },
  ];

  return (
    <div className="blog-container">
      <h1 className="blog-title">Blog</h1>
      <p className="blog-subtitle">
        Discover the latest handpicked blog entries to get started.
      </p>

      <br />
      <br />

      <div className="blog-grid">
        {blogs.map((blog) => (
          <Link to={blog.link} className="blog-card" key={blog.id}>
            <div className="blog-image">
              <img src={blog.image} alt={blog.title} />
              <span className="blog-category">{blog.tag}</span>
            </div>
            <div className="blog-content">
              <h3 className="blog-heading">{blog.title}</h3>
              <p className="blog-description">{blog.description}</p>
              <div className="blog-footer">
                <span className="blog-date">
                    <span style={{ marginRight: '8px' }}>📅</span>{blog.date} • {blog.readTime}
                </span>
                {/* ✅ Changed a → Link */}
                <Link to={blog.link} className="read-more-h">
                  Read more →
                </Link>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Blog;
